






import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component({})
export default class WysiwygTextarea extends Vue {
    @Prop({ type: String, default: 'html' }) private activeView?: string;
    @Prop({ type: String, default: '' }) private content?: string;

    get view(): string | undefined {
        return this.activeView;
    }

    set view(value: string | undefined) {
        this.$emit('activeView:update', value);
    }

    get textareaClass(): string[] {
        const result: string[] = ['wysiwyg-textarea'];

        if (this.view !== 'html') {
            result.push('show-raw');
        }

        return result;
    }

    @Watch('activeView')
    private onActiveViewChanged(newValue: string, oldValue: string): void {
        this.view = newValue;

        const Entities = require('html-entities').AllHtmlEntities;
        const entities = new Entities();
        const beautify = require('js-beautify').html;
        const contentElement: any = this.$refs.content;

        contentElement.innerHTML = newValue === 'html' ? entities.decode(contentElement.innerHTML) : entities.encode(beautify(contentElement.innerHTML));
    }

    private mounted(): void {
        const contentElement: any = this.$refs.content;
        contentElement.innerHTML = this.content;
    }

    private getState(): void {
        document.queryCommandState('bold') === true ? this.$emit('state', 'bold', true) : this.$emit('state', 'bold', false);
        document.queryCommandState('italic') === true ? this.$emit('state', 'italic', true) : this.$emit('state', 'italic', false);
        document.queryCommandState('strikeThrough') === true ? this.$emit('state', 'strikeThrough', true) : this.$emit('state', 'strikeThrough', false);
        document.queryCommandState('underline') === true ? this.$emit('state', 'underline', true) : this.$emit('state', 'underline', false);
        document.queryCommandState('justifyLeft') === true ? this.$emit('state', 'justifyLeft', true) : this.$emit('state', 'justifyLeft', false);
        document.queryCommandState('justifyCenter') === true ? this.$emit('state', 'justifyCenter', true) : this.$emit('state', 'justifyCenter', false);
        document.queryCommandState('justifyRight') === true ? this.$emit('state', 'justifyRight', true) : this.$emit('state', 'justifyRight', false);
        document.queryCommandState('justifyFull') === true ? this.$emit('state', 'justifyFull', true) : this.$emit('state', 'justifyFull', false);

        this.$emit('textState', document.queryCommandValue('formatBlock'));
    }

    private updateContent(event: any) {
        this.$emit('updateContent', event.target.innerHTML);
    }
}
